import React from "react";
import { getInitialData } from "../../service/apiFetch";
import Detail from "../../components/Blog/Detail";
export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps = async (context) => {
  const { uri } = context.params;
  const initialData = await getInitialData(`blog/${uri}`, {
    limit: 10,
    select: "createdAt,title,description,featureImg,metaTags",
  });
  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      type: initialData?.type || "",
      url: initialData?.url || "",
      error: initialData?.error || ""
    },
  };
};
export default function blogDetail({ data, type }) {
  return (
    <div>
        {/* {JSON.stringify(data)} */}
    
      {type == "BlogPost" ? (
        <Detail data={data} />
      ) : (
        <div>
          <h3 className="py-[5rem] text-[16px] sm:text-[20px] font-semibold text-[#2d5a81] text-center">
            No Blog Available
          </h3>
        </div>
      )}
    </div>
  );
}
